// @flow
import React from 'react'
import PropTypes from 'prop-types'
import { Fields } from 'redux-form'
import FieldBlock from '../forms/field-block'
import CtaButton from '../buttons/cta-button'
import FlatButton from '../buttons/flat-button'
import Notification from '../notifications/notification'
import { GridRow, GridCol } from '../grid/'
import LocationSearchBox from '../maps/LocationSearchBox'
import {
  SELECT_ADDRESS_ERROR,
  US_ONLY_ERROR
} from '../../services/validations/locations'

const CharityLocationForm = (props: Object) => {
  const {
    handleSubmit,
    handleCancel,
    locationPlaceholder,
    invalid,
    dirty,
    pristine,
    submitting,
    locationText,
    errorSelectAddressText,
    errorOnlyUSNotificationText,
    notifyWhenOutOfUSAvailableText,
    cancelText,
    saveText,
    error
  } = props
  return (
    <form onSubmit={handleSubmit}>
      <FieldBlock
        className='label-space'
        titleLabel='Where is your Charity located?'
      >
        <Fields
          names={['location', 'lng', 'lat', 'country', 'countryCode']}
          id='location'
          component={LocationSearchBox}
          label={locationText}
          placeholder={locationPlaceholder}
          theme='dark-theme'
          displayMap
          hasText
          autoFocus
        />
      </FieldBlock>
      {invalid &&
        dirty &&
        error === SELECT_ADDRESS_ERROR && (
          <Notification status='warning' iconName='warning'>
            <p>{errorSelectAddressText}</p>
          </Notification>
        )}
      {invalid &&
        dirty &&
        error === US_ONLY_ERROR && (
          <Notification status='error' iconName='warning'>
            <p>{errorOnlyUSNotificationText}</p>
            <p>
              <strong>{notifyWhenOutOfUSAvailableText}</strong>
            </p>
          </Notification>
        )}
      <GridRow className='bottom-space top-space'>
        <GridCol type='one-half'>
          <FlatButton
            text={cancelText}
            isInverse
            type='button'
            onClick={handleCancel}
            disabled={submitting}
          />
        </GridCol>
        <GridCol type='one-half pull-right'>
          <CtaButton
            hasIcon={false}
            text={saveText}
            type='submit'
            disabled={pristine || invalid || submitting}
            isLoading={submitting}
          />
        </GridCol>
      </GridRow>
    </form>
  )
}

CharityLocationForm.propTypes = {
  handleSubmit: PropTypes.func,
  handleCancel: PropTypes.func,
  pristine: PropTypes.bool.isRequired,
  dirty: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  locationText: PropTypes.string,
  locationPlaceholder: PropTypes.string,
  errorSelectAddressText: PropTypes.string.isRequired,
  errorOnlyUSNotificationText: PropTypes.string.isRequired,
  notifyWhenOutOfUSAvailableText: PropTypes.string.isRequired,
  cancelText: PropTypes.string.isRequired,
  saveText: PropTypes.string.isRequired,
  error: PropTypes.string
}

export default CharityLocationForm



// WEBPACK FOOTER //
// ./src/ui/forms/charity-location-form.js